import React, { KeyboardEvent } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { MdOutlineDragIndicator } from "react-icons/md";
import { BsFillTrashFill } from "react-icons/bs";
import { CheckItem } from "../../types/checkItem";

type Props = {
  item: CheckItem;
  updateItem: (index: number, label: string) => void;
  removeItem: (index: number) => void;
};

const SortableItem: React.FC<Props> = ({ item, updateItem, removeItem }: Props) => {
  const handleChange = (e) => {
    updateItem(item.index, e.target.value);
  };

  // Enterキーを押したときにボタンが押されないようにする
  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: item.index,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style} className="row m-0 mb-2 rounded border p-2">
      <span className="d-flex justify-content-center align-items-center col-1" {...attributes} {...listeners}>
        <MdOutlineDragIndicator />
      </span>
      <input type="text" value={item.label} onChange={handleChange} onKeyDown={handleKeyDown} className="form-control col-9" />
      <span className="col-1" />
      <button
        type="button"
        className="btn btn-outline-danger col-1"
        onClick={() => {
          removeItem(item.index);
        }}
      >
        <BsFillTrashFill />
      </button>
    </div>
  );
};

export default SortableItem;
